import React, { useRef, useState } from 'react';

// material-ui
import {
  AppBar,
  Box,
  Button,
  LinearProgress,
  Slide,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography
} from '@mui/material';
import Dialog from '@mui/material/Dialog';

import EmptyBoxIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// project imports

import { useSnackbar } from 'notistack';
import { useConnections } from '../../../hooks/useConnections';
import { useActiveSgbuildexElement } from '../../../hooks/useExtraction';
import { dataElement } from '../../../utils/utils';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SgbuildexModuleScreen({ open, onClose, onConfirm, setSnackbar }) {
  const payloadForm = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const { data: dataConnection, isFetching: isLoadingConnection, isError } = useConnections();
  const { mutate: activateElement, isPending: isActivateElement, isSuccess: isSuccessActivate } = useActiveSgbuildexElement();

  const handleSelectProject = (data) => {};

  const [openFormModal, setopenFormModal] = useState(false);

  const handleActivateElement = (param, connectionId) => {
    const {name} = dataElement.find(res => res.id === param)
    console.log({connectionId, param, name})
    const payload = {
      connectionId,
      element: param
    }
    activateElement(payload, {
      onSuccess: () => {
        // closeDialog('success', type);
        onConfirm("success", name)
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Activate Element failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
   
  };
  
  const elementData = dataElement.filter(res => res.id === "site_progress" ||  res.id === "concrete_cube_test_laboratory")

  const isPageLoading = isLoadingConnection;
  const connectionList = dataConnection?.filter((res) => res.provider === 'sgbuildex') || [];

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={onClose}
        slots={{
          transition: Transition
        }}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h5" component="div">
              List Project
            </Typography>
            <Button autoFocus color="inherit" onClick={onClose}>
              CLOSE
            </Button>
          </Toolbar>
        </AppBar>

        <Box mt={5} px={1}>
          {isPageLoading && (
            <Box
              sx={{
                width: '100%'
              }}
            >
              <LinearProgress />
            </Box>
          )}
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: '35%' }}>
                    <strong>Project Name</strong>
                  </TableCell>
                  <TableCell sx={{ width: '65%' }}>
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {connectionList.length > 0 ? (
                  connectionList.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{row?.metadata?.data?.identity?.name}</TableCell>

                      <TableCell>
                        <Stack direction={'row'} spacing={1}>
                          {elementData.map(res => (
                              <Button
                              sx={{ fontWeight: 'bold' }}
                              onClick={() => handleActivateElement(res.id, row.id)}
                              variant="outlined"
                            >
                              {res.name}
                            </Button>
                          ))}
                        
                          {/* <Button
                            sx={{ fontWeight: 'bold' }}
                            // endIcon={<KeyboardArrowDownIcon />}
                            onClick={() => handleActivateElement("site_progress")}
                            variant="outlined"
                            //   startIcon={<VisibilityOutlinedIcon />}
                          >
                            Site Progress
                          </Button> */}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          py: 4
                        }}
                      >
                        <Box
                          sx={{
                            width: 50,
                            height: 50,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <InboxOutlinedIcon
                            sx={{
                              fontSize: 50,
                              color: 'grey.400'
                            }}
                          />
                        </Box>

                        <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary' }}>
                          No Project Data
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Dialog>
    </>
  );
}
